module.exports = __webpack_public_path__ + "img/das-c-1.424a7299.jpg";